import { Route, Switch } from "react-router-dom";
import "./App.css";
import Home from "./components/Home";
import { AnimatePresence } from "framer-motion";
import Login from "./components/Login";
import Signup from "./components/Signup";
import About from "./components/About";
import Contact from "./components/Contact";
import Profile from "./components/Patient/Profile";
import Dashboard from "./components/Patient/Dashboard";
import MyDashboard from "./components/Doctor/myDashboard";
import MyProfile from "./components/Doctor/myProfile";
import Step1 from "./components/Appointment/step1";
import Step2 from "./components/Appointment/step2&3";
import Step4 from "./components/Appointment/step4";
import Prescription from "./components/prescription";
import VideoConference from "./components/VideoConferrance";
import Modal from "./components/utils/Modal";

function App() {
  return (
    <div className="App">
      <Switch>
        <Route path="/" exact component={Home} />
        <Route path="/videoconsultation/:id" exact component={VideoConference} />
        <Route path="/about" exact component={About} />
        <Route path="/contact" exact component={Contact} />
        <Route path="/patient/profile" exact component={Profile} />
        <Route path="/patient/dashboard" exact component={Dashboard} />
        <Route path="/doctor/mydashboard" exact component={MyDashboard} />
        <Route path="/doctor/myprofile" exact component={MyProfile} />  
        <Route path="/bookingstep1" exact component={Step1} />  
        <Route path="/bookingstep2" exact component={Step2} />  
        <Route path="/bookingstep4" exact component={Step4} />  
        <Route path="/prescription" exact component={Prescription} />  
        <Route path="/doctor/mydashboard/add" exact component={Modal} />  
        <Route render={({location})=>{
          window.scrollTo({top: 0, behavior: "smooth"})
          return <div style={{position:"relative"}}>
          <AnimatePresence>
            <Switch location={location} key={location.pathname}>
              <Route exact path="/login" component={Login} />
              <Route exact path="/signup" component={Signup} />
            </Switch>
          </AnimatePresence>
        </div>
        }} />
      </Switch>
    </div>
  );
}

export default App;
